"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = require("react-dom");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _components = require("components");

var _containerCarousel = require("./containerCarousel.scss");

var _containerCarousel2 = _interopRequireDefault(_containerCarousel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ContainerCarousel = function (_React$Component) {
  (0, _inherits3.default)(ContainerCarousel, _React$Component);

  function ContainerCarousel(props, context) {
    (0, _classCallCheck3.default)(this, ContainerCarousel);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ContainerCarousel.__proto__ || (0, _getPrototypeOf2.default)(ContainerCarousel)).call(this, props, context));

    _this.state = {
      modal: {
        show: false,
        strings: {}
      }
    };

    _this.handleModal = _this.handleModal.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(ContainerCarousel, [{
    key: "handleModal",
    value: function handleModal(strings) {
      if (this.state.modal.show) {
        this.setState({
          modal: {
            show: false,
            strings: this.state.modal.strings
          }
        });
        return;
      }

      this.setState({
        modal: {
          show: true,
          strings: strings
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var strings = this.props.strings;

      var modalProps = (0, _extends3.default)({}, this.state.modal, {
        onClose: this.handleModal
      });
      return _react2.default.createElement(
        "div",
        { className: "containerCarousel" },
        _react2.default.createElement(_components.CarouselModal, modalProps),
        _react2.default.createElement(_components.Carousel, { strings: strings, handleModal: this.handleModal })
      );
    }
  }]);
  return ContainerCarousel;
}(_react2.default.Component);

exports.default = ContainerCarousel;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ContainerCarousel/ContainerCarousel.jsx
// module id = 694
// module chunks = 0